import { Col, Row, Typography } from "antd";

import RealStateListViewItem from "apps/RealState/Common/ListViewItem";
import ListViewItemHeader from "apps/RealState/Common/ListViewItemHeader";
import MazakaCard from "apps/Common/MazakaCart";
import Banner from "../../Banner";
import MLSInfoes from "./MLSInfoes";
import RealStateDetailsIndex from "apps/RealState/Details/ProductDetails";

const RegisterPotentialAdIndex = () => {
  const { Text } = Typography;

  let item = {
    lat: 38.694521,
    lng: 35.478886,
    galleryList: [
      {
        src: "https://a0.muscache.com/im/pictures/22aa2faf-3186-469a-b4af-bf2b33f5e56c.jpg?im_w=720",
      },
      {
        src: "https://a0.muscache.com/im/pictures/hosting/Hosting-U3RheVN1cHBseUxpc3Rpbmc6MTAyMzA3ODM4Nzc5MzIzMTY3Ng%3D%3D/original/6c1f1e8f-a8ae-48a5-a131-b8a16d949f24.jpeg?im_w=720",
      },
    ],
    price: "150.000,00",
    location: "Melikgazi, Kayseri",
    name: "Lüks Daire",
    type: "Daire",
    floor: "2.kat",
    rooms: "4+1",
    width: "100m²",
    status: "acil",
  };

  return (
    <Col xs={24}>
      <Row gutter={[0, 20]}>
        <MazakaCard xs={24} gutter={[0, 20]}>
          <MLSInfoes />
        </MazakaCard>
        <MazakaCard xs={24} gutter={[0, 20]}>
          <Col xs={24} className="!flex justify-center">
            <Text className="!text-2xl !font-bold">İlan Detayı</Text>
          </Col>
          {/* <RealStateDetailsIndex /> */}
        </MazakaCard>
      </Row>
    </Col>
  );
};

export default RegisterPotentialAdIndex;
